<template>
  <div class="maxh-1bar scroll-y pa-3 d-flex">
    <OJumbo class="w-full opacity-5" question v-if="value.vehicle == null">
      Este módulo não está associado a nenhum veículo.
    </OJumbo>

    <template v-else>
      <div class="w-1/2 pa-3 d-flex flex-column">
        <VehicleDetails2 :vehicle="value.vehicle" @reload="emitReload" />

        <div class="py-6">
          <VehicleCounters
            ref="counters"
            :vehicle="value.vehicle"
            @reload="emitReload"
          />
        </div>
      </div>
      <div class="w-1/2 pa-3">
        <ConfigList2 ref="configs" :vehicle="value.vehicle" />
      </div>
    </template>
  </div>
</template>

<script>
import VehicleDetails2 from '../../vehicle/VehicleDetails2.vue'
import ConfigList2 from '../../vehicle/configs2/ConfigList.vue'
import VehicleCounters from '../../vehicle/VehicleCounters.vue'

export default {
  expose: ['reload'],
  tabTitle: 'Configuração',
  tabGroup: 'Veículo',
  components: {
    VehicleDetails2,
    ConfigList2,
    VehicleCounters
  },
  props: {
    value: { required: true }
  },
  methods: {
    emitReload() {
      this.$emit('reload')
    },
    reload() {
      this.$refs.counters.reload()
      this.$refs.configs.reload()
    }
  }
}
</script>

<style></style>
